// Componente para mostrar un cuadro de información con un icono.
// Displays an information box with an icon.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';

interface InfoBoxProps {
  message: string;
}

export const InfoBox = ({ message }: InfoBoxProps) => {
  return (
    <div className="flex items-center gap-2 p-3 bg-card-bg border border-card-border rounded-lg text-sm mb-8">
      <FontAwesomeIcon icon={faInfoCircle} className="w-4 h-4" />
      <span>{message}</span>
    </div>
  );
};
